import { currentPage } from '../common/layout';
import { updateShortDescriptionBox } from '../common/short-description';
import 'jquery-scrolltie';
import { getM1FindVehicleEu, getM1FindVehicleUs, getM1FindVehicleByType } from '../common/shop/m1-find-vehicle-widget-loader';
import { getCoralCommentsCountUpdate } from '../common/utils/coral-requests-loader';
import '../common/jquery-snap-scroll';
import '../common/jquery.sticky';
import 'jquery.dotdotdot';
// import '../common/lazyload.picture';

currentPage.pageInit = ($page, pageData, pageId) => {
    let currentEdition = document.querySelector('body').dataset.edtn;
    //bigImgLazyload();
    $('.sidebar').stickySidebar({ containerSelector: '.content-area' });
    $('.ss-slider').snapScrollControll();     

    var $img = $('.reload img.m1-cse-item_image');

    if ($img.length > 0) {
        var qLenght = $img.length - 1;
        $(window).on('load', function(){
            $img.each(function(i, q) {
                if (i === qLenght && $img[qLenght].complete){
                    $('.reload .msnt-items-slider_slide').css('height','100%');
                    return false;
                }
            });
        })
    }

	$('#top_box .item .poster').scrollTie({
	    property: 'translateY',
        delay: function(el){
        	return 350;
        },
	    stopAtValue: document.documentElement.clientHeight,
	    speed: isTouch ? 0.15 : 0.3
    });
    
    let previews = document.querySelectorAll('.item.m1-submodel-rating');
    let showHideButton = document.querySelector('#show-hide-button');
    let boxIsExpanded = false;
    
    // for (let i = 0; i < previews.length; i++) {
    //     if (i > 5) {
    //         previews[i].classList.add('hidden-preview');
    //     }
    // }

    // $('.hidden-preview').wrapAll('<div id="hidden-previews" class="hidden-previews collapsible" />');
    
    if (showHideButton) {
        showHideButton.addEventListener('click', function(e) {
            e.preventDefault();
            boxIsExpanded = !boxIsExpanded;
            let hiddenPreview = document.querySelectorAll('.item.m1-submodel-rating');

            if (boxIsExpanded) {
                hiddenPreview.forEach((elem, elemIndex) => {
                    if (elemIndex > 5) {
                        elem.style.display = 'inline-block';
                    }
                })

                $('.browseBox.thumb-box .item .info .text-box').dotdotdot({
                    height: 'watch',
                    ellipsis: '...',
                    truncate: 'word',
                  });
            } else {
                hiddenPreview.forEach((elem, elemIndex) => {
                    if (elemIndex > 5) {
                        elem.style.display = 'none';
                    }
                })
            }
            // showHideButton.style.display = 'none';
            
            // if (section.style.maxHeight){
            //     section.style.maxHeight = null;
            // } else {
            //     section.style.maxHeight = 'max-content';
            // }
        }); 
    }


    getM1FindVehicleEu().then((api) => {
        api.m1FindVehicleEu();
    });
    getM1FindVehicleUs().then((api) => {
        api.m1FindVehicleUs();
    });
	getM1FindVehicleByType().then((api) => {
        api.m1FindVehicleByType();
    });
    getCoralCommentsCountUpdate().then((api) => {
        api.coralCommentsCountUpdate();
    });
    $('.ss-slider').snapScrollControll();

    if ($(".short-description").length > 0) {
        // const hiddenArea = $("#about-make .browseBox > div");

        // $("#loadMore").on('click', function () {
        //     hiddenArea.css('max-height', hiddenArea.css('max-height') ===  '0px'
        //         ? hiddenArea.prop('scrollHeight') + 'px'
        //         : '0px');
        // });

        updateShortDescriptionBox();
        window.addEventListener("resize", updateShortDescriptionBox);
    }
}